export function nextPracticeFilterValue(current, selected) {
  if (selected === '전체') return '전체';
  return current === selected ? '전체' : selected;
}
